import axios from "api/client";

// The API keeps the session in an httpOnly cookie: login and register set
// it, logout clears it, /me says who is signed in.
export default {
  login: (credentials) => axios.post("/auth/login", credentials),
  register: (payload) => axios.post("/auth/register", payload),
  logout: () => axios.post("/auth/logout"),
  me: () => axios.get("/me"),
  update: (data) => axios.put("/users", data),
};
